import React, { Component } from 'react';
import notFoundImage from '../img/404.png';

class NotFound extends Component {
  render() {
    return(
      <div class="notFound">
        <img src={notFoundImage} alt={"notFoundImage"} />
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/notFound.js